export default {"src":"/_next/static/media/text_strip_3.2770d36e.svg","height":7,"width":278,"blurWidth":0,"blurHeight":0};